import React, { useState } from 'react';
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

// Use the environment variable if set (for production), otherwise default to localhost
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Sending...');

    try {
      const response = await fetch(`${API_BASE_URL}/api/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        setStatus('Message sent successfully!');
        setFormData({ name: '', email: '', message: '' });
      } else {
        setStatus(data.message || 'Failed to send message.');
      }
    } catch (error) {
      console.error('Error:', error);
      setStatus('An error occurred. Please try again.');
    }
  };

  return (
    <div className="bg-gray-50 text-deepgreen min-h-screen font-sans">
      <Navbar />

      {/* Header Section */}
      <section className="bg-deepgreen text-white py-24 px-6">
        <div className="max-w-6xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-serif font-extrabold mb-6" data-aos="fade-up">
            Get in Touch
          </h1>
          <p className="text-lg md:text-xl text-gray-200 max-w-3xl mx-auto" data-aos="fade-up" data-aos-delay="100">
            We’re here to assist you. Reach out by filling the form below or use the contact details provided to schedule a legal consultation.
          </p>
        </div>
      </section>

      <section className="px-6 py-20 max-w-6xl mx-auto -mt-16 relative z-10">
        <div className="grid md:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div className="space-y-8" data-aos="fade-right">
            <div className="bg-white p-8 rounded-xl shadow-xl border-l-4 border-gold">
              <h3 className="text-2xl font-serif font-bold mb-6 text-deepgreen">Contact Information</h3>
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <span className="text-2xl">✉️</span>
                  <div>
                    <h4 className="font-bold text-gold uppercase text-sm tracking-wide">Email</h4>
                    <a href="mailto:odiranandaadvocate@gmail.com" className="text-gray-700 hover:text-deepgreen transition">odiranandaadvocate@gmail.com</a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <span className="text-2xl">📞</span>
                  <div>
                    <h4 className="font-bold text-gold uppercase text-sm tracking-wide">Phone</h4>
                    <a href="tel:+254759738111" className="text-gray-700 hover:text-deepgreen transition">+254 759 738 111</a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <span className="text-2xl">📍</span>
                  <div>
                    <h4 className="font-bold text-gold uppercase text-sm tracking-wide">Office Location</h4>
                    <p className="text-gray-700">Ground Floor, Professional Centre,<br/>Parliament Road, Nairobi</p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Office Hours */}
            <div className="bg-deepgreen text-white p-8 rounded-xl shadow-xl">
              <h3 className="text-xl font-serif font-bold mb-4">Office Hours</h3>
              <p className="text-gray-300 mb-2">Monday - Friday: 8:00 AM - 5:00 PM</p>
              <p className="text-gray-300">Saturday: 9:00 AM - 1:00 PM</p>
              <p className="text-gray-300">Sunday: Closed</p>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-white p-8 rounded-xl shadow-xl" data-aos="fade-left">
            <h3 className="text-2xl font-serif font-bold mb-6 text-deepgreen">Send Us a Message</h3>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="block mb-2 font-medium text-gray-700">Full Name</label>
                <input
                  id="name"
                  type="text"
                  name="name"
                  placeholder="Jane Doe"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full border border-gray-300 px-4 py-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold focus:border-transparent transition duration-200"
                />
              </div>

              <div>
                <label htmlFor="email" className="block mb-2 font-medium text-gray-700">Email Address</label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  placeholder="jane@example.com"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full border border-gray-300 px-4 py-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold focus:border-transparent transition duration-200"
                />
              </div>

              <div>
                <label htmlFor="message" className="block mb-2 font-medium text-gray-700">Your Message</label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  placeholder="How can we help you?"
                  required
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full border border-gray-300 px-4 py-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold focus:border-transparent transition duration-200"
                ></textarea>
              </div>

              <button
                type="submit"
                className="w-full bg-gold text-deepgreen font-bold py-4 px-6 rounded-lg hover:bg-deepgreen hover:text-white transition duration-300 shadow-md"
              >
                {status === 'Sending...' ? 'Sending...' : 'Send Message'}
              </button>
              {status && (
                <div className={`text-center font-semibold mt-4 p-3 rounded ${status.includes('success') ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                  {status}
                </div>
              )}
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default ContactPage;
